import { Box, Button, Flex, Select, SimpleGrid, TextInput } from '@mantine/core'
import { modals } from '@mantine/modals'
import RichText from '@v2/commons/components/RichText/RichText'

import addEmailDomainToUserUseCase from '../../hook/addEmailDomainToUser.hook'

interface AddEmailDomainToUserProps {
  userMembershipId: string
}

const EmailTypeOptions = [
  { label: 'Send', value: 'SEND' },
  { label: 'Reply', value: 'REPLY' },
  { label: 'Both', value: 'BOTH' },
]

const AddEmailDomainToUser = ({
  userMembershipId,
}: AddEmailDomainToUserProps) => {
  const { onSubmit, form, isLoading, catalogEmailDomains } =
    addEmailDomainToUserUseCase()
  form.setFieldValue('membershipId', userMembershipId)
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <TextInput
        key={form.key('name')}
        label="Name"
        withAsterisk
        {...form.getInputProps('name')}
      />
      <SimpleGrid cols={2} spacing="xl" verticalSpacing="xl" my="md">
        <Select
          key={form.key('emailDomainId')}
          label="Email Address - Domain"
          withAsterisk
          placeholder="Select Email address - domain"
          data={catalogEmailDomains}
          allowDeselect={false}
          {...form.getInputProps('emailDomainId')}
          searchable
        />
        <Select
          key={form.key('type')}
          label="Type of Email Domain"
          withAsterisk
          placeholder="Select type of email domain"
          data={EmailTypeOptions}
          allowDeselect={false}
          {...form.getInputProps('type')}
        />
      </SimpleGrid>
      <Box flex={1}>
        <RichText
          withAsterisk
          label="Email Signature"
          value=""
          className=""
          key={form.key('signatureTemplate')}
          {...form.getInputProps('signatureTemplate')}
          placeholder="Your Message..."
          showAttachments={false}
          showHtmlTextButton={true}
        />
      </Box>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button loading={isLoading} type="submit" variant="filled">
          Save
        </Button>
      </Flex>
    </form>
  )
}

export const addEmailDomainToUserModal = (userMembershipId: string) =>
  modals.open({
    title: 'Add Email Domain',
    centered: true,
    children: <AddEmailDomainToUser userMembershipId={userMembershipId} />,
    size: 'lg',
    radius: 'md',
  })
